//#region redux
import { useDispatch } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { displayDialog } from "store/actions/utilActions";
//#endregion
//#region types
import { TranslationKeys } from "translations";
//#endregion
//#region components
import useAddExtraSalaryDialog from "./forms/useAddExtraSalaryDialog";
import { StyledButton } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const AddExtraSalaryButton: React.FC = (props) => {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const addExtraSalaryDialog = useAddExtraSalaryDialog();

  const onAddSalaryButtonClick = async () => {
    dispatch(displayDialog(addExtraSalaryDialog));
  };

  return (
    <StyledButton size="sm" onClick={onAddSalaryButtonClick}>
      {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Salary.AddExtraSalary)}
    </StyledButton>
  );
};

export default AddExtraSalaryButton;
